import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getCheckoutsArchiveLoading: false,
  getCheckoutsArchiveFailed: false,
  getCheckoutsArchiveError: false,
  getCheckoutsArchiveMessage: null,
  checkoutsArchive: [],

  getReservesCheckoutArchiveLoading: false,
  getReservesCheckoutArchiveFailed: false,
  getReservesCheckoutArchiveError: false,
  getReservesCheckoutArchiveMessage: null,
  checkoutArchiveReserves: [],

  getCheckoutArchiveDetailsLoading: false,
  getCheckoutArchiveDetailsFailed: false,
  getCheckoutArchiveDetailsError: false,
  getCheckoutArchiveDetailsMessage: null,
  checkoutArchiveDetails: {},

  checkoutArchive: {
    totalRecords: 0,
  },
  checkoutArchiveReserve: {
    totalRecords: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_CHECKOUT_ARCHIVE_LOADING: {
      return {
        ...state,
        getCheckoutsArchiveLoading: true,
        getCheckoutsArchiveFailed: false,
        getCheckoutsArchiveError: false,
        getCheckoutsArchiveMessage: null,
        checkoutsArchive: [],
      };
    }
    case actionTypes.GET_CHECKOUT_ARCHIVE_SUCCESS: {
      return {
        ...state,
        getCheckoutsArchiveLoading: false,
        getCheckoutsArchiveFailed: false,
        getCheckoutsArchiveError: false,
        getCheckoutsArchiveMessage: null,
        checkoutArchive: {
          ...action.payload,
        },
        checkoutsArchive: [...action.payload.checkoutWithCafes],
      };
    }
    case actionTypes.GET_CHECKOUT_ARCHIVE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCheckoutsArchiveLoading: false,
        getCheckoutsArchiveFailed: true,
        getCheckoutsArchiveError: false,
        getCheckoutsArchiveMessage: message,
      };
    }
    case actionTypes.GET_CHECKOUT_ARCHIVE_REJECT: {
      return {
        ...state,
        getCheckoutsArchiveLoading: false,
        getCheckoutsArchiveFailed: false,
        getCheckoutsArchiveError: true,
        getCheckoutsArchiveMessage: null,
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_LOADING: {
      return {
        ...state,
        getReservesCheckoutArchiveLoading: true,
        getReservesCheckoutArchiveFailed: false,
        getReservesCheckoutArchiveError: false,
        getReservesCheckoutArchiveMessage: null,
        checkoutArchiveReserves: [],
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_SUCCESS: {
      return {
        ...state,
        getReservesCheckoutArchiveLoading: false,
        getReservesCheckoutArchiveFailed: false,
        getReservesCheckoutArchiveError: false,
        getReservesCheckoutArchiveMessage: null,
        checkoutArchiveReserve: {
          ...action.payload,
        },
        checkoutArchiveReserves: [...action.payload.reserves],
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getReservesCheckoutArchiveLoading: false,
        getReservesCheckoutArchiveFailed: true,
        getReservesCheckoutArchiveError: false,
        getReservesCheckoutArchiveMessage: message,
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_REJECT: {
      return {
        ...state,
        getReservesCheckoutArchiveLoading: false,
        getReservesCheckoutArchiveFailed: false,
        getReservesCheckoutArchiveError: true,
        getReservesCheckoutArchiveMessage: null,
      };
    }

    case actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_LOADING: {
      return {
        ...state,
        getCheckoutArchiveDetailsLoading: true,
        getCheckoutArchiveDetailsFailed: false,
        getCheckoutArchiveDetailsError: false,
        getCheckoutArchiveDetailsMessage: null,
      };
    }
    case actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_SUCCESS: {
      return {
        ...state,
        getCheckoutArchiveDetailsLoading: false,
        getCheckoutArchiveDetailsFailed: false,
        getCheckoutArchiveDetailsError: false,
        getCheckoutArchiveDetailsMessage: null,
        checkoutArchiveDetails: {
          ...action.payload,
        },
      };
    }
    case actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCheckoutArchiveDetailsLoading: false,
        getCheckoutArchiveDetailsFailed: true,
        getCheckoutArchiveDetailsError: false,
        getCheckoutArchiveDetailsMessage: message,
      };
    }
    case actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_REJECT: {
      return {
        ...state,
        getCheckoutArchiveDetailsLoading: false,
        getCheckoutArchiveDetailsFailed: false,
        getCheckoutArchiveDetailsError: true,
        getCheckoutArchiveDetailsMessage: null,
      };
    }

    default:
      return state;
  }
};
